// Fixed, code-defined list of feedback "feature areas" used to auto-assign
// in-app feedback submissions to the right team member. Deliberately not
// database-driven — built from an actual route/state inventory of the app.
// Mirrored in backend/utils/feedbackFeatureAreas.js — keep both in sync by
// hand when this list changes.

export type FeatureArea =
  | "design_canvas"
  | "design_sketchbook"
  | "design_preview"
  | "home_studio"
  | "home_personal"
  | "pwf_classic"
  | "pwf_studio"
  | "portal_activities"
  | "portal_workspace"
  | "portal_groups"
  | "chats_dm"
  | "chats_ai_builder"
  | "spaces"
  | "mentoring"
  | "marketplace"
  | "insights"
  | "programs"
  | "meetings_builder"
  | "meetings_room"
  | "activities_run"
  | "review"
  | "account"
  | "admin"
  | "contact"
  | "marketing_pages"
  | "uncategorized";

export const FEATURE_AREAS: FeatureArea[] = [
  "design_canvas",
  "design_sketchbook",
  "design_preview",
  "home_studio",
  "home_personal",
  "pwf_classic",
  "pwf_studio",
  "portal_activities",
  "portal_workspace",
  "portal_groups",
  "chats_dm",
  "chats_ai_builder",
  "spaces",
  "mentoring",
  "marketplace",
  "insights",
  "programs",
  "meetings_builder",
  "meetings_room",
  "activities_run",
  "review",
  "account",
  "admin",
  "contact",
  "marketing_pages",
  "uncategorized",
];

export const FEATURE_AREA_LABELS: Record<FeatureArea, string> = {
  design_canvas: "Design — Canvas editing",
  design_sketchbook: "Design — Sketchbook",
  design_preview: "Design — Preview",
  home_studio: "Home — Studio",
  home_personal: "Home — Personal Cockpit",
  pwf_classic: "PWF — Classic",
  pwf_studio: "PWF — Studio",
  portal_activities: "Portal — Activities",
  portal_workspace: "Portal — My Workspace",
  portal_groups: "Portal — My Groups",
  chats_dm: "Chats — Direct Messages",
  chats_ai_builder: "Chats — AI Builder (Clary)",
  spaces: "Spaces",
  mentoring: "Mentoring",
  marketplace: "Marketplace",
  insights: "Insights",
  programs: "Programs",
  meetings_builder: "Meetings — Builder",
  meetings_room: "Meetings — Room",
  activities_run: "Activities — Running",
  review: "Process review",
  account: "Account",
  admin: "Admin area",
  contact: "Contact page",
  marketing_pages: "Marketing / onboarding pages",
  uncategorized: "Uncategorized",
};
